export default __webpack_public_path__ + "static/media/bgSub.2ffbb4d2.png";